import {
  DashboardView,
  LoadingView,
} from 'pages/RedesignDashboard/components/DashboardView';
import { withSecureServices } from 'hoc/page.hoc';
import { usePageView } from 'hook/helper.hook';
import { OVERVIEW } from 'types/mrph.pages.constants';
import { useDashboardPage } from 'pages/RedesignDashboard/hooks/dashboardPage.hook';
import { loadPotentialCreditProfileContainer } from 'actions/dashboard.actions';
import { useDispatch } from 'react-redux';
import HelmetContainer from 'components/HelmetContainer/HelmetContainer';
import { useAcknowledgePrescreen } from 'hook/acknowledgePrescreen.hook';
import { checkNeedCapOnePrescreenAcknowledge } from 'helpers/common';

const RedesignDashboardController = props => {
  const {
    globalLoadingFlag,
    userInfo,
    creditInfo,
    eventHandler,
    location,
    history,
  } = props;

  const {
    staticModules,
    staticModulesThree,
    profileContainer,
    potentialCreditProfileContainer,
    todayContainer,
    profileContainerLoading,
    potentialCreditProfileContainerLoading,
    todayContainerLoading,
    selectedBureau,
    selectedFactor,
    isFactorContainerLoading,
    loadTodayDashboard,
    onBureauSelection,
    isFreeSignUpBannerShow,
    resetPotentialCreditProfileDashboard,
    potentialCreditProfileContainerError,
    goToFactorPage,
    showModuleAvailableForYou,
  } = useDashboardPage({ userInfo, creditInfo, location, history });

  const loading =
    globalLoadingFlag ||
    !staticModulesThree ||
    !staticModules ||
    !selectedBureau;
  usePageView(loading);

  const dispatch = useDispatch();

  const handleTryAgainPotentialCreditProfile = props => {
    resetPotentialCreditProfileDashboard();
    dispatch(loadPotentialCreditProfileContainer());
  };

  const todayContainerHasModules = todayContainer?.modules?.length > 0;

  const profileContainerHasModules = profileContainer?.modules?.length > 0;

  const todayContainerNeedCapOne = checkNeedCapOnePrescreenAcknowledge(
    todayContainer?.modules,
  );

  useAcknowledgePrescreen({
    awaitExecution:
      todayContainerLoading ||
      profileContainerLoading ||
      loading ||
      !todayContainerHasModules ||
      !profileContainerHasModules ||
      !todayContainerNeedCapOne,
  });

  if (loading) {
    return <LoadingView />;
  } else {
    return (
      <>
        <HelmetContainer title={'Offers'} />
        <DashboardView
          {...props}
          staticModules={staticModules}
          staticModulesThree={staticModulesThree}
          profileContainer={profileContainer}
          potentialCreditProfileContainer={potentialCreditProfileContainer}
          todayContainer={todayContainer}
          profileContainerLoading={profileContainerLoading}
          potentialCreditProfileContainerLoading={
            potentialCreditProfileContainerLoading
          }
          todayContainerLoading={todayContainerLoading}
          selectedBureau={selectedBureau}
          selectedFactor={selectedFactor}
          loadTodayDashboard={loadTodayDashboard}
          onBureauSelection={onBureauSelection}
          isFactorContainerLoading={isFactorContainerLoading}
          eventHandler={eventHandler}
          isFreeSignUpBannerShow={isFreeSignUpBannerShow}
          handleTryAgainPotentialCreditProfile={
            handleTryAgainPotentialCreditProfile
          }
          potentialCreditProfileContainerError={
            potentialCreditProfileContainerError
          }
          goToFactorPage={goToFactorPage}
          location={location}
          showModuleAvailableForYou={showModuleAvailableForYou}
        />
      </>
    );
  }
};

const connectedNewDashboardController = withSecureServices(
  RedesignDashboardController,
  {
    pageNameType: OVERVIEW,
    scrollToTop: true,
    skipScrollToTop: false,
    initialState: {
      key: false,
    },
  },
);

export default connectedNewDashboardController;
